<app-card
  [iconSrc]="'assets/images/contracts/claims.svg'"
  [title]="title || 'Claims'"
  class="card_claims"
>
  <div class="card-content">
    <div *ngIf="!isLoading && claims?.length == 0" class="no-data">
      No Claims reported yet
    </div>
    <div class="claim-list claims-styling">
      <div class="container-claim-list-table custom-table">
        <table class="table-style">
          <thead>
            <tr class="tr-style">
              <th class="th-style" scope="col">CLAIM #</th>
              <th class="th-style" scope="col" *ngIf="showContractNumber">CONTRACT NUMBER</th>
              <th class="th-style" scope="col">CONTRACT EXIST</th>
              <th class="th-style" scope="col">CLAIM CUSTOMER</th>
              <th class="th-style" scope="col">AMOUNT</th>
              <th class="th-style" scope="col">PAID AT</th>
              <th class="th-style" scope="col">SELLER</th>
              <th class="th-style" scope="col">PRODUCT</th>
              <th class="th-style" scope="col">REPAIR FACILITY</th>
              <th class="th-style" scope="col" *ngIf="showLienHolder">LIEN HOLDER</th>
              <th class="th-style" scope="col">THIRD PARTY PAID</th>
              <th class="th-style" scope="col">
                <img
                  alt=""
                  src="./assets/images/claim-icons/settings-inactive.svg"
                />
              </th>
            </tr>
          </thead>
          <tbody *ngIf="!isLoading && claims?.length">
            <tr *ngFor="let claim of claims; index as i" class="tr-style">
              <td
                class="td claim-number"
                class="td-style"
                data-thead="Claim Number"
              >
                <a
                  [routerLink]="
                    '/dashboard/claims/claim-details/' +
                    claim?.customer?.claim_id
                  "
                >
                  <span>{{ claim?.claim_number }}</span>
                </a>
              </td>
              <td class="td-style" data-thead="Contract Number" *ngIf="showContractNumber">
                <span>{{ getContractNumber(claim) }}</span>
              </td>
              <td class="td" class="td-style">
                <span>{{ claim?.contract ? "Yes" : "" }}</span>
              </td>
              <td class="td-style" data-thead="Claim ADJUSTER">
                <span>
                  {{
                    claim?.customer?.customer_name | allLettersCapital : true
                  }}</span
                >
              </td>
              <td class="td-style" data-thead="Amount">
                {{ claim?.amount | formattedCurrency }}
              </td>
              <td class="td-style" data-thead="Amount">
                {{ claim?.paid_at | formattedDateTime }}
              </td>
              <td class="td-style" data-thead="Seller">
                <span>{{ claim?.seller || 'N/A' }}</span>
              </td>
              <td class="td-style" data-thead="Product">
                <span>{{ claim?.product || 'N/A' }}</span>
              </td>
              <td class="td-style" data-thead="Repair Facility">
                <span>{{ claim?.repair_facility || 'N/A' }}</span>
              </td>
              <td class="td-style" data-thead="Lien Holder" *ngIf="showLienHolder">
                <span>{{ claim?.lien_holder || 'N/A' }}</span>
              </td>
              <td class="td-style" data-thead="Third Party Paid">
                <span>{{ claim?.third_party_paid || 'N/A' }}</span>
              </td>
              <td class="td-style" data-thead="">
                <img
                  (click)="claimDetails(claim?.id)"
                  src="./assets/images/file-text.svg"
                  alt="edit"
                  style="cursor: pointer"
                />
              </td>
            </tr>
          </tbody>
          <tbody *ngIf="isLoading">
            <tr *ngFor="let row of [1, 2, 3]; index as i">
              <td>
                <ngx-skeleton-loader appearance="line"></ngx-skeleton-loader>
              </td>
              <td *ngIf="showContractNumber">
                <ngx-skeleton-loader appearance="line"></ngx-skeleton-loader>
              </td>
              <td *ngIf="showLienHolder">
                <ngx-skeleton-loader appearance="line"></ngx-skeleton-loader>
              </td>
              <td>
                <ngx-skeleton-loader appearance="line"></ngx-skeleton-loader>
              </td>
              <td>
                <ngx-skeleton-loader appearance="line"></ngx-skeleton-loader>
              </td>
              <td>
                <ngx-skeleton-loader appearance="line"></ngx-skeleton-loader>
              </td>
              <td>
                <ngx-skeleton-loader appearance="line"></ngx-skeleton-loader>
              </td>
              <td>
                <ngx-skeleton-loader appearance="line"></ngx-skeleton-loader>
              </td>
              <td>
                <ngx-skeleton-loader appearance="line"></ngx-skeleton-loader>
              </td>
              <td>
                <ngx-skeleton-loader appearance="line"></ngx-skeleton-loader>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</app-card>
